import { useMemo } from 'react';

export const useBrowserDetection = () => {
  return useMemo(() => {
    const userAgent = navigator.userAgent;
    
    // ÉTAPE 1 : Détecter la plateforme
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isAndroid = /Android/.test(userAgent);
    
    // ÉTAPE 2 : Détecter le navigateur selon la plateforme
    let isSafari = false;
    let isChrome = false;
    let isFirefox = false;
    let isEdge = false;
    
    if (isIOS) {
      // Sur iOS : utiliser les identifiants spécifiques
      // (tous les navigateurs iOS utilisent WebKit mais ont des identifiants uniques)
      isChrome = /CriOS/.test(userAgent);      // Chrome iOS = CriOS
      isFirefox = /FxiOS/.test(userAgent);     // Firefox iOS = FxiOS
      isEdge = /EdgiOS/.test(userAgent);       // Edge iOS = EdgiOS
      isSafari = !isChrome && !isFirefox && !isEdge; // Safari si aucun autre
    } else {
      // Sur Android/Desktop : utiliser les regex standards
      isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) && !userAgent.includes('Chrome');
      isChrome = /Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor);
      isFirefox = /Firefox/.test(userAgent);
      isEdge = /Edg/.test(userAgent);
    }
    
    const isMobile = isIOS || isAndroid;

    // Appareil Apple : iPhone/iPad (isIOS) ou macOS. iPadOS 13+ se présente
    // avec une UA « Macintosh » sur Safari, on le couvre donc via Mac aussi.
    const isAppleDevice = isIOS || /Macintosh|Mac OS X/i.test(userAgent);

    return {
      isSafari,
      isChrome,
      isFirefox,
      isEdge,
      isIOS,
      isAndroid,
      isMobile,
      isAppleDevice,
    };
  }, []);
};
